import React from "react";
import BBTFlightCheckinBanner from "../../images/BBTCheckInSmall.png";
import { useNavigate } from "react-router-dom";

const FlightCheckInSmallBanner = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/web-flight-check-in");
  };

  return (
    <div
      style={{ position: "relative", display: "inline-block", width: "100%" }}
    >
      <img
        src={BBTFlightCheckinBanner}
        alt="Flight Check-In Banner"
        style={{ width: "100%", height: "auto", display: "block" }}
      />

      {/* Adjust the following div to match the button's position on the image */}
      <div
        onClick={handleClick}
        style={{
          position: "absolute",
          left: "10%", // adjust X position of button
          top: "65%", // adjust Y position of button
          width: "14%", // adjust width of clickable area
          height: "18%", // adjust height of clickable area
          cursor: "pointer",
          borderRadius: "34px",
        }}
        title="Be Our Travel Partner"
      />
    </div>
  );
};

export default FlightCheckInSmallBanner;
